import { TestRun } from '../../types';
import resultsComparer from './resultsComparer';

const failRateComparer = (a: TestRun, b: TestRun) => {
  if (a.test_runs.fail_rate === b.test_runs.fail_rate) {
    return resultsComparer(b, a);
  }
  return a.test_runs.fail_rate - b.test_runs.fail_rate;
};

export default failRateComparer;
